module.exports = __webpack_public_path__ + "img/7-3s.edc0c068.jpg";